/* eslint-disable no-nested-ternary */
import { Icon, InputText } from "@bluframe/blublocks"
import colors from "styles/colors"

import { Wrapper } from "../styled"
import { ComponentProps } from "."

const Text = ({
  disabled,
  hasValid,
  id,
  isValid,
  label,
  name,
  onChange,
  text
}: ComponentProps) => (
  <Wrapper>
    <InputText
      disabled={disabled}
      iconStart={
        hasValid ? (
          isValid ? (
            <Icon
              color={colors.apple}
              group="fa6"
              name="FaCircleCheck"
              size="18"
              title="valid"
            />
          ) : (
            <Icon
              color={colors.red}
              group="fa6"
              name="FaCircleXmark"
              size="18"
              title="invalid"
            />
          )
        ) : null
      }
      inputId={id}
      label={label}
      name={name}
      onChange={onChange}
      value={text}
    />
  </Wrapper>
)

export default Text
